// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowAction-module_textContent__UY568 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    flex: 1 0 0;
    min-width: 0;
    overflow: hidden;
    text-align: left;
}

.rowAction-module_topTextContent__IHpWs {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/rowAction.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".textContent {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 8px;\n    flex: 1 0 0;\n    min-width: 0;\n    overflow: hidden;\n    text-align: left;\n}\n\n.topTextContent {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `rowAction-module_textContent__UY568`,
	"topTextContent": `rowAction-module_topTextContent__IHpWs`
};
export default ___CSS_LOADER_EXPORT___;
